import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import '../Applicant/Grant.css';
import Navbar from '../../Components/Navbar';
import Navbar2Edit from '../../Components/Navbar2Edit';
import Sidebar from '../../Components/Sidebar';
import { useNavigate } from 'react-router-dom';
import { useForm } from '../Applicant/MainForm'; // Context to handle form data centrally
import axios from 'axios'; // Import axios for HTTP requests
import { API_BASE_URL } from '../../config';

export default function Grant() {
  const { formData, handleFormDataChange,updateCompletionStatus, resetFormData } = useForm(); // Use form context
  const [formErrors, setFormErrors] = useState({}); // Define state for form errors
  const [submitted, setSubmitted] = useState(false); // Define state for form submission
  const [isSubmitted, setIsSubmitted] = useState(false); 
  const navigate = useNavigate();

  // Handle file input changes
  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (files.length > 0) {
      handleFormDataChange({ [name]: files[0] }); // Save the file object in the form data
    }
  };

  // Validation function to check required fields
  const validate = () => {
    let errors = {};

    //Check if each required file input has a value
    if (!formData.projectProposal || !(formData.projectProposal instanceof File)) {
      errors.projectProposal = 'Project Proposal is required.';
    }

    if (!formData.projectBudget || !(formData.projectBudget instanceof File)) {
      errors.projectBudget = 'Project Budget is required.';
    }

    if (!formData.projectCV || !(formData.projectCV instanceof File)) {
      errors.projectCV = 'Project CV is required.';
    }

    if (!formData.coInvestigatorsCVs || !(formData.coInvestigatorsCVs instanceof File)) {
      errors.coInvestigatorsCVs = 'Co-investigators CVs are required.';
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0; // Return true if no errors
  };

  // Function to handle form submission
  const handleSubmit = async () => {
    if (validate()) {
      try {
        const formDataToSend = new FormData();
        for (const key in formData) {
          if (formData[key] instanceof File) {
            // Extract filename and send as string
            formDataToSend.append(key, formData[key]);
          } else {
            formDataToSend.append(key, formData[key]);
          }
        }

        // Debugging: Log FormData entries
        for (let pair of formDataToSend.entries()) {
          console.log(pair[0] + ', ' + pair[1]);
        }

        const response = await axios.post(`${API_BASE_URL}/FileUploads.php`, formDataToSend, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });

        alert(response.data);
        setSubmitted(true); // Set form as submitted
      } catch (error) {
        alert('There was an error submitting the form. Please try again.');
      }
    }
  };

  
  const handleSave = async () => {
    if (isSubmitted) {
      alert('Form data has already been saved.');
      return; // Prevent further submissions
    }
  
    try {
      // Step 1: Save the form data
      const response = await axios.post(`${API_BASE_URL}/SaveForm.php`, formData, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        transformRequest: [(data) => {
          const params = new URLSearchParams();
          for (const key in data) {
            params.append(key, data[key]);
          }
          return params;
        }],
      });
  
      if (response.data.status === 'success') {
        setIsSubmitted(true);
        alert('Form saved successfully.');
  
        // Step 2: Upload the files
        const fileUploadResponse = await axios.post(`${API_BASE_URL}/SaveFileUploads.php`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
  
        console.log(fileUploadResponse.data); 
  
        if (fileUploadResponse.data.status === 'success') {
          alert('Files uploaded successfully.');
  
          // Step 3: Filter out relevant data for MultipleRows.php
          const relevantData = {
            grantRows: formData.grantRows,
            fundingRows: formData.fundingRows,
            co_investigators: formData.co_investigators, // Add the multiple rows for supervisors here
          };
  
          // Step 4: Submit the filtered data to MultipleRows.php
          const multipleRowsResponse = await axios.post(`${API_BASE_URL}/SaveMultipleRows.php`, relevantData, {
            headers: {
              'Content-Type': 'application/json', // Set content type to JSON for MultipleRows.php
            },
          });
  
          console.log(multipleRowsResponse.data); // Log the response for debugging
  
          if (multipleRowsResponse.data.status === "success") {
            localStorage.removeItem('formData');
            resetFormData();
            navigate('/submittedgrant'); // Navigate to the submitted grant page
          } else {
            alert('Submission to MultipleRows.php failed: ' + multipleRowsResponse.data.message);
          }
        } else {
          alert(fileUploadResponse.data.message);
        }
      } else {
        alert(response.data.message);
      }
    } catch (error) {
      console.error('Error details:', error);
      alert('There was an error saving the data or uploading files. Please try again.');
    }
  };

  // Navigate to the next form page
  const handleNext = async () => {
    if (validate()) {
      updateCompletionStatus('uploads', true);
      navigate('/reviewers'); // Update this path to the correct next page
    } else {
      alert('Missing Fields Required.');
    }
  };

  // Navigate to the previous form page
  const handlePrevious = () => {
    navigate('/supervisors'); // Navigate to the previous page
  };

  return (
    <div>
      <Navbar />
      <Navbar2Edit />
      <Sidebar />

      <div className="form-container">
        {submitted && (
          <div className="alert alert-success" role="alert">
            Form submitted successfully!
          </div>
        )}
        <Form onSubmit={handleSubmit}>
          <Row className="mb-3">
            <Form.Group controlId="formProjectProposal">
              <Form.Label>1. Upload Project Proposal (Please Upload PDF a File) <span className="text-danger">*</span></Form.Label>
              <Form.Control
                type="file"
                name="projectProposal"
                onChange={handleFileChange}
                isInvalid={!!formErrors.projectProposal}
              />
              <Form.Control.Feedback type="invalid">
                {formErrors.projectProposal}
              </Form.Control.Feedback>
              {formData.projectProposal && (
                <div className="file-name">
                  {formData.projectProposal.name}
                </div>
              )}
            </Form.Group>

            <Form.Group controlId="formProjectBudget">
  <Form.Label>
    2. Upload Project Budget (Please Upload PDF a File) <span className="text-danger">*</span>
  </Form.Label>
  <div>
    <a 
      href="/Templates/Project Budget.docx" 
      download="Project Budget.docx"
      className="template-download-link"
    >
      Download the template here
    </a>
  </div>
  <Form.Control
    type="file"
    name="projectBudget"
    onChange={handleFileChange}
    isInvalid={!!formErrors.projectBudget}
  />
  <Form.Control.Feedback type="invalid">
    {formErrors.projectBudget}
  </Form.Control.Feedback>
  {formData.projectBudget && (
    <div className="file-name">
      {formData.projectBudget.name}
    </div>
  )}
</Form.Group>


            <Form.Group controlId="formProjectCV">
              <Form.Label>3. Upload Project Full CV of the Principal Investigator (Please Upload PDF a File) <span className="text-danger">*</span></Form.Label>
              <Form.Control
                type="file"
                name="projectCV"
                onChange={handleFileChange}
                isInvalid={!!formErrors.projectCV}
              />
              <Form.Control.Feedback type="invalid">
                {formErrors.projectCV}
              </Form.Control.Feedback>
              {formData.projectCV && (
                <div className="file-name">
                  {formData.projectCV.name}
                </div>
              )}
            </Form.Group>

            <Form.Group controlId="formCoInvestigatorsCVs">
              <Form.Label>4. Upload Project two page CVs of all the co-investigators (compile to single pdf) <span className="text-danger">*</span></Form.Label>
              <Form.Control
                type="file"
                name="coInvestigatorsCVs"
                onChange={handleFileChange}
                isInvalid={!!formErrors.coInvestigatorsCVs}
              />
              <Form.Control.Feedback type="invalid">
                {formErrors.coInvestigatorsCVs}
              </Form.Control.Feedback>
              {formData.coInvestigatorsCVs && (
                <div className="file-name">
                  {formData.coInvestigatorsCVs.name}
                </div>
              )}
            </Form.Group>
          </Row>

          {/* <Button variant="primary" onClick={handleSave} type="button" className="savebutton">
            Save
          </Button> */}
          <Button variant="primary" onClick={handlePrevious} className="previousbutton">
            Previous
          </Button>
          <Button variant="primary" onClick={handleNext} className="nextbutton">
            Next
          </Button>
        </Form>
      </div>
    </div>
  );
}
